
//２点間の距離
const toTimeStr = (millsec) =>
{
  let min = 0;
  let sec = 0;

  //分
  if(millsec >= 60000)
  {
    min = Math.floor(millsec / 60000);
    millsec -= min*60000;
  }

  //秒
  if(millsec >= 1000)
  {
    sec = Math.floor(millsec / 1000);
    millsec -= sec*1000;
  }

  if(min < 10) min = '0' + min;
  if(sec < 10) sec = '0' + sec;
  if(millsec < 10)
  {
    millsec = '00' + millsec;
  }
  else if(millsec < 100)
  {
    millsec = '0' + millsec
  }

  return min + ':' + sec + ':' + millsec;
}

const TimeUtil = {
  toTimeStr: toTimeStr,
}
export default TimeUtil